const links = {
     
     //seniorzoom:"https://hack.af/z-join?id=ygbetb",
     //juniorzoom:"https://hack.af/z-join?id=lnbxhz",
     //zoom:"https://hack.af/z-join?id=ygbetb",
     
     seniorzoom:"https://hack.af/z-join?id=lnbxhz",
     juniorzoom:"https://hack.af/z-join?id=lnbxhz",
     zoom:"https://hack.af/z-join?id=lnbxhz",

//      seniorzoom:"https://hack.af/z-join?id=unkgj4",
//      juniorzoom:"https://hack.af/z-join?id=unkgj4",
//      zoom:"https://hack.af/z-join?id=unkgj4",
         
}

export const ExternalLinks = ({linkName}) => {
    return <>{window.location.replace(links[linkName])}</>
}
